import { useState } from "react";
import Campo from "../../components/Campo";
import Logo from "../../components/Logo";
import styles from "./styles.module.css";

function RecuperarSenha() {
  const [emailRecuperacao, setEmail] = useState("");
  return (
    <section className={styles.recoverPg}>
      <header>
        <Logo />
      </header>
      <main>
        <form className={styles.formRecover}>
          <h2>
            Recuperar <strong>Senha</strong>:
          </h2>
          <Campo
            title="Digite seu email"
            placeholder="Digite o seu email"
            type="email"
            required={true}
            value={emailRecuperacao}
            setter={setEmail}
          />
          <p>
            Uma mensagem será enviada para o seu email com a recuperação de
            senha
          </p>
          <hr className={styles.separador} />
          <input type="submit" value="Recuperar senha" />
        </form>
      </main>
    </section>
  );
}
export default RecuperarSenha;
